import FilterSelect from './FilterSelect';
import FilterItem from './FilterItem';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AppState, selectDeviceType } from 'core/redux/reducers';
import actions from 'core/redux/features/filters/actions';
import { activeFilterToggled, useFilterState } from '../store';
import MultiSelectBox from '../../../../Components/Elements/Buttons/MultiSelectBox';
import { useTrans } from '../../../../core/hooks';

export const PersonFilter = (props: {
  parentRef: React.RefObject<HTMLElement>;
}) => {
  const { parentRef } = props;
  const {
    filterState: { activeFilter },
    filterDispatch,
  } = useFilterState();
  const persons = useSelector((state: AppState) => state.filters.persons);
  const activeFilters = useSelector(
    (state: AppState) => state.filters.activeFilters,
  );
  const dispatch = useDispatch();
  const deviceType = useSelector(selectDeviceType);
  const trans = useTrans();
  const activeLabel = persons.find(
    item => item.id === activeFilters.person,
  )?.label;

  const [personOptions, setPersonOptions] = useState([]);
  useEffect(() => {
    if (deviceType === 'mobile') {
      setPersonOptions(
        persons
          .filter(val => val.id > 0)
          .map(item => ({ ...item, label: trans(item.label) })),
      );
    }
  }, [trans, deviceType, persons]);

  return (
    <FilterItem
      onClick={() => {
        filterDispatch(activeFilterToggled('person'));
      }}
      name="filter-person"
      label=""
      className="filter-checkbox-column"
      isOpen={activeFilter === 'person'}
    >
      {deviceType === 'mobile' ? (
        <MultiSelectBox
          multi={false}
          controlMobile={deviceType === 'mobile'}
          onClose={() => {
            filterDispatch(activeFilterToggled('person'));
          }}
          onSave={persons => {
            if (persons.length > 0 && activeFilters.person !== persons[0]) {
              dispatch(actions.selectPerson(persons[0] as number));
            } else {
              dispatch(actions.selectPerson(0));
            }
          }}
          parentRef={parentRef}
          headerName={trans('people')}
          name={trans(activeLabel, {}, activeLabel)}
          options={personOptions}
          id="person"
          selectedOptions={[activeFilters.person]}
          isActiveDropdown={activeFilter === 'person'}
        />
      ) : (
        <FilterSelect
          activeOnHover={false}
          onSelect={(e, item) => {
            e.preventDefault();
            if (activeFilters.person !== item.id) {
              dispatch(actions.selectPerson(item.id));
            }
            filterDispatch(activeFilterToggled('person'));
          }}
          isActive={false}
          name="filter-person"
          selected={{ id: activeFilters.person }}
          options={persons}
        />
      )}
    </FilterItem>
  );
};
